@use "ui/styles/breakpoints";
@use "ui/styles/sizes";
@use "ui/styles/colors";

.categoryRadioGroup {
  display: flex;

  @include breakpoints.mobile-device {
    flex-direction: column;
  }
}

.categoryRadioGroupOption {
  &:not(:last-child) {
    margin-right: sizes.$s7;
  }

  @include breakpoints.mobile-device {
    margin-right: 0;
    margin-bottom: sizes.$s6;
  }
}

.locationPlanCards {
  padding: sizes.$s2;
}

.totalPriceOverrideToggle {
  display: flex;
  align-items: center;
  gap: sizes.$s2;
  margin-top: sizes.$s7;
  color: colors.$gray60;
}

.incompatibleOptionSetContainer {
  margin-top: sizes.$s4;

  .optionSetList {
    padding-top: sizes.$s3;
    padding-bottom: sizes.$s3;
  }
}

.homePlanModal {
  margin: 12px auto;
}

.multiUnitHomePlanModal {
  :global(.modal-body) {
    margin-top: sizes.$s5;
  }
}

.multiUnitInfoMessage {
  margin-bottom: sizes.$s7;
}
